<template>
  <WorkQuestionDialog
    ref="dialog"
    v-bind="$props"
    width="sm"
    :message="$t('Dialogs.BeforeLeaveDialog.message')"
  >
    <template #dialog-actions="{ triggerResolve, triggerReject, close }">
      <WorkButton
        outlined
        @click="close"
      >
        {{ $t('Dialogs.BasicDialog.abort') }}
      </WorkButton>

      <WorkButton @click="triggerReject()">
        {{ $t('Dialogs.BeforeLeaveDialog.abort') }}
      </WorkButton>

      <WorkButton @click="triggerResolve()">
        {{ $t('Dialogs.BeforeLeaveDialog.accept') }}
      </WorkButton>
    </template>
  </WorkQuestionDialog>
</template>

<script>
// components
import WorkQuestionDialog from "@/components/base_components/dialog/icon-dialogs/WorkQuestionDialog";
import WorkButton from "@/components/global_components/buttons/WorkButton";
import { ref } from 'vue';

export default {
  name: "WorkBeforeLeaveDialog",
  components: {
    WorkQuestionDialog,
    WorkButton,
  },
  setup() {
    const dialog = ref(null);

    function open() {
      return dialog.value.open();
    }
    return { open, dialog }
  }
}
</script>
